import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import { useContent } from "@/lib/content";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";

export default function Contact() {
  const { data: s = {} } = useQuery({ queryKey: ["settings"], queryFn: async () => (await publicApi.get("/settings")).data });
  const { t } = useContent();

  const rows = [
    { icon: Mail, label: "Email", value: s.contact_email, href: `mailto:${s.contact_email}` },
    { icon: Phone, label: "Phone", value: s.contact_phone, href: `tel:${s.contact_phone}` },
    { icon: MapPin, label: "Showroom", value: s.address },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <p className="overline-label mb-2">{t("contact.overline")}</p>
          <h1 className="font-serif text-4xl lg:text-5xl text-cream">{t("contact.title")}</h1>
          <p className="mt-6 text-muted2 leading-relaxed">{s.about}</p>

          <div className="mt-10 space-y-5">
            {rows.map((r) => r.value && (
              <div key={r.label} data-testid={`contact-${r.label.toLowerCase()}`} className="flex items-start gap-4">
                <span className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center text-gold shrink-0"><r.icon className="w-5 h-5" /></span>
                <div>
                  <p className="overline-label">{r.label}</p>
                  {r.href ? <a href={r.href} className="text-cream hover:text-gold">{r.value}</a> : <p className="text-cream">{r.value}</p>}
                </div>
              </div>
            ))}
          </div>

          <div className="flex gap-4 mt-10">
            {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors"><Instagram className="w-5 h-5" /></a>}
            {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors"><Facebook className="w-5 h-5" /></a>}
          </div>
        </div>

        <div className="gold-card !border-gold/30 overflow-hidden">
          <img src={s.hero_image} alt="Idea Events showroom" className="w-full h-full object-cover min-h-[24rem]" />
        </div>
      </div>
    </div>
  );
}
